import { FC } from 'react';

import { withA11yVisuallyHidden } from '@telialt/common-a11y/src/withA11yVisuallyHidden';

import { PriceTagElement } from './PriceTag.styles';

const PriceTagAccessible = withA11yVisuallyHidden(PriceTagElement);

type Props = { price: string; priceA11y: string; className?: string };
export const PriceTag: FC<Props> = ({ price, priceA11y, className }) => {
    return (
        <PriceTagAccessible accessible={priceA11y} className={className}>
            {price}
        </PriceTagAccessible>
    );
};
